var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#57A5FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6365 14.4391L20 18.0756L16.3634 14.4391C15.9172 13.9928 15.1934 13.9928 14.7472 14.4391L13.9391 15.2472C13.4928 15.6934 13.4928 16.4172 13.9391 16.8635L17.5756 20.5L13.9391 24.1365C13.4928 24.5828 13.4928 25.3066 13.9391 25.7528L14.7472 26.5609C15.1934 27.0072 15.9172 27.0072 16.3634 26.5609L20 22.9244L23.6365 26.5609C24.0828 27.0072 24.8065 27.0071 25.2528 26.5609L26.0609 25.7528C26.5071 25.3066 26.5071 24.5828 26.0609 24.1365L22.4244 20.5L26.0609 16.8635C26.5071 16.4172 26.5071 15.6934 26.0609 15.2472L25.2528 14.4391C24.8065 13.9929 24.0828 13.9928 23.6365 14.4391Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fe79296494e9de4bb2c6e332c766b488.svg";
export { ForwardRef as ReactComponent };